<template>
	<label>
		<em class="lt_text">Item {{ headers.class }} Group</em>
		<span class="int_type_no_border mgr_5">
			<CodeSelect className="tbl_select sm_int" :codes="codes" v-model="code" @input="updateValue" :disabled="disabled" />
		</span>
	</label>
</template>

<script>
import { apiSelectCodeList } from '@/api/basicinfo/code';
import CodeSelect from '@/components/common/CodeSelect';

export default {
	name: 'ItemClassGroup',
	data: function() {
		return {
			codes: [],
			code: '',
			active_yn: 'Y',
		};
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
	},
	methods: {
		async selectData() {
			const { data } = await apiSelectCodeList({
				code_type: 'ICG',
				active_yn: this.active_yn,
			});
			this.codes = data.codeList;
		},
		updateValue() {
			this.$emit('input', this.code);
		},
		reset() {
			this.code = '';
		},
	},
	components: {
		CodeSelect,
	},
	mounted() {
		this.selectData();
	},
};
</script>

<style scoped></style>
